/**
 * Перетаскивание HTML эл-та по столу
 */
export default class DraggableHtmlElement
{
    private element: HTMLElement|null = null;

    private isOnDrag: boolean = false;
    private pos1 = 0;
    private pos2 = 0;
    private pos3 = 0;
    private pos4 = 0;
    private newTop = 0;
    private newLeft = 0;

    constructor(element: HTMLElement) {
        this.element = element
    }

    /**
     * Обработчик mousedown
     * @param e
     */
    public onMousedownHandler(e: any): void
    {
        this.isOnDrag = true;
        // get the mouse cursor position at startup:
        this.pos3 = e.clientX;
        this.pos4 = e.clientY;
    }

    /**
     * Обработчик mousemove
     * @param e
     */
    public onMousemoveHandler(e: any): void
    {
        if (!this.element || !this.isOnDrag) {
            return;
        }

        // calculate the new cursor position:
        this.pos1 = this.pos3 - e.clientX;
        this.pos2 = this.pos4 - e.clientY;
        this.pos3 = e.clientX;
        this.pos4 = e.clientY;
        // set the element's new position:
        this.newTop = this.element.offsetTop - this.pos2;
        this.newLeft = this.element.offsetLeft - this.pos1;
        this.element.style.top = this.newTop + "px";
        this.element.style.left = this.newLeft + "px";
    }

    /**
     * Обработчик mouseup
     */
    public onMouseupHandler()
    {
        this.triggerEvent('dragEnd', {top: this.newTop, left: this.newLeft});
        this.isOnDrag = false;
        this.newLeft = 0;
        this.newTop = 0;
    }

    /**
     * Тригер события
     * @param {string} eventName
     * @param data
     */
    private triggerEvent(eventName: string, data?: any): void
    {
        if (!this.element) {
            return;
        }

        let event = new CustomEvent(eventName, {
            detail: data
        });
        this.element.dispatchEvent(event);
    }
}
